import { Component, Input } from '@angular/core';

interface ServiceItem {
  title: string;
  subtitle1: string;
  subtitle2: string;
}

@Component({
  selector: 'mapfre-service-item',
  templateUrl: './service-item.component.html',
  styleUrls: ['./service-item.component.scss']
})
export class ServiceItemComponent {
  @Input() image;
  @Input() data: ServiceItem;

  constructor() {}
}
